import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

const predictiveTargetingMessageTemplate = _TL_('Predictive targeting is {0}', "The placeholder will display either 'on' or 'off'.");
const predictiveTargetingOn = _TL_('on');
const predictiveTargetingOff = _TL_('off');

export const PredictiveTargeting = ({ isPredictiveTargetingEnabled }) => {
  const i18n = useContext(I18nContext);

  const predictiveTargetingText = i18n.getString(predictiveTargetingMessageTemplate).replace('{0}', isPredictiveTargetingEnabled ? predictiveTargetingOn : predictiveTargetingOff);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Predictive targeting') }}>
      <Text>{predictiveTargetingText}</Text>
    </PropertyRow>
  );
};

PredictiveTargeting.propTypes = {
  isPredictiveTargetingEnabled: PropTypes.bool,
};

PredictiveTargeting.defaultProps = {
  isPredictiveTargetingEnabled: false,
};
